import React from "react";
import "./Home.css";

export default () => {
  return (
    <div className="home">
      <div className="hero">
        <div className="hero-content">
          <h2>
            The smarter way to get from <strong>contract</strong> to{" "}
            <em>closed</em>.
          </h2>
          <p>
            ​Successful real estate agents know that their time is best spent
            lead generating and growing their business, not focusing on the time
            consuming details that come with paperwork and file management.
          </p>
        </div>
      </div>
      <div className="home-content">
        <section>
          <ul className="home-breakdown">
            <li>
              <h3>Availability</h3>
              <p>
                Real estate often happens outside of "normal" business hours, so
                we make ourselves reasonably available when you need us! We
                provide quick responses to requests and ensure every detail is
                handled quickly, to avoid any delays.
              </p>
            </li>
            <li>
              <h3>Smarter Systems​</h3>
              <p>
                Here at Closing Bot, we implement smart systems to effectively
                manage each and every detail of your file ​with the care,
                professionalism and knowledge necessary to get you and your
                clients to the closing table!
              </p>
            </li>
            <li>
              <h3>​Experience​</h3>
              <p>
                {" "}
                Your clients and files are being managed by a ​​licensed
                REALTOR® with over {new Date().getFullYear() - 2010} years of
                experience in sales and operations management for top producing
                teams.
              </p>
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/Home.js